import React, { createContext, useContext, useState } from "react";


export const translations = {
    "Frazza": { en: "Frazza", es: "Frazza", de: "Frazza" },
    "Features": { en: "Features", es: "Características", de: "Funktionen" },
    "Pricing": { en: "Pricing", es: "Precios", de: "Preise" },
    "About us": { en: "About us", es: "Sobre nosotros", de: "Über uns" },
    "Because Distance Shouldn't Mean Disconnection": {
        en: "Because Distance Shouldn't Mean Disconnection",
        es: "Porque la distancia no debería significar desconexión",
        de: "Denn Entfernung sollte keine Trennung bedeuten"
    },
    "Frazza aims to be the ultimate platform for couples, providing an intuitive tool that strengthens connection, simplifies organization, and enriches time together, no matter the distance.": {
        en: "Frazza aims to be the ultimate platform for couples, providing an intuitive tool that strengthens connection, simplifies organization, and enriches time together, no matter the distance.",
        es: "Frazza aspira a ser la plataforma definitiva para parejas, proporcionando una herramienta intuitiva que fortalece la conexión, simplifica la organización y enriquece el tiempo juntos, sin importar la distancia.",
        de: "Frazza möchte die ultimative Plattform für Paare sein, die ein intuitives Werkzeug bietet, das die Verbindung stärkt, die Organisation vereinfacht und die gemeinsame Zeit bereichert – egal wie groß die Entfernung ist."
    },
    "Get Started →": { en: "Get Started →", es: "Comenzar →", de: "Loslegen →" },
    "Learn More": { en: "Learn More", es: "Saber más", de: "Mehr erfahren" },
    "Everything You Need to Stay Connected": {
        en: "Everything You Need to Stay Connected",
        es: "Todo lo que necesitas para mantenerte conectado",
        de: "Alles, was Sie brauchen, um in Verbindung zu bleiben"
    },
    "Support Us": {
        en: "Support Us",
        es: "Apóyanos",
        de: "Unterstütze uns"
    },
    "Buy Me a Coffee": {
        en: "Buy Me a Coffee",
        es: "Cómpranos un café",
        de: "Spendiere uns einen Kaffee"
    },
    "If you enjoy using Frazza, consider buying us a coffee!": {
        en: "If you enjoy using Frazza, consider buying us a coffee!",
        es: "Si disfrutas usando Frazza, ¡considera comprarnos un café!",
        de: "Wenn dir Frazza gefällt, spendiere uns doch einen Kaffee!"
    },
    "Support independent developers": {
        en: "Support independent developers",
        es: "Apoya a desarrolladores independientes",
        de: "Unterstütze unabhängige Entwickler"
    },
    "Help us improve Frazza": {
        en: "Help us improve Frazza",
        es: "Ayúdanos a mejorar Frazza",
        de: "Hilf uns, Frazza zu verbessern"
    },
    "Enable new features": {
        en: "Enable new features",
        es: "Permite nuevas funciones",
        de: "Neue Funktionen ermöglichen"
    },
    "Show your appreciation": {
        en: "Show your appreciation",
        es: "Muestra tu agradecimiento",
        de: "Zeige deine Wertschätzung"
    },
    "Donate Now": {
        en: "Donate Now",
        es: "Donar ahora",
        de: "Jetzt spenden"
    },
    "From shared calendars to movie nights, Frazza brings couples together with tools designed for love across any distance.": {
        en: "From shared calendars to movie nights, Frazza brings couples together with tools designed for love across any distance.",
        es: "Desde calendarios compartidos hasta noches de cine, Frazza une a las parejas con herramientas diseñadas para el amor a cualquier distancia.",
        de: "Von gemeinsamen Kalendern bis zu Filmabenden – Frazza bringt Paare mit Tools zusammen, die für Liebe über jede Distanz entwickelt wurden."
    },
    "Shared Todos": { en: "Shared Todos", es: "Tareas compartidas", de: "Gemeinsame Aufgaben" },
    "Keep track of tasks together. See what your partner is working on and celebrate completed goals as a team.": {
        en: "Keep track of tasks together. See what your partner is working on and celebrate completed goals as a team.",
        es: "Lleven un seguimiento de las tareas juntos. Vean en qué está trabajando su pareja y celebren los logros alcanzados como equipo.",
        de: "Behalten Sie Aufgaben gemeinsam im Blick. Sehen Sie, woran Ihr Partner arbeitet, und feiern Sie erreichte Ziele als Team."
    },
    "Synchronized Calendar": { en: "Synchronized Calendar", es: "Calendario sincronizado", de: "Synchronisierter Kalender" },
    "Plan visits, important dates, and shared events. Never miss an anniversary or special moment again.": {
        en: "Plan visits, important dates, and shared events. Never miss an anniversary or special moment again.",
        es: "Planifiquen visitas, fechas importantes y eventos compartidos. Nunca más se pierdan un aniversario o momento especial.",
        de: "Planen Sie Besuche, wichtige Termine und gemeinsame Ereignisse. Verpassen Sie nie wieder einen Jahrestag oder besonderen Moment."
    },
    "Shared Notes": { en: "Shared Notes", es: "Notas compartidas", de: "Gemeinsame Notizen" },
    "Create a digital notebook together. Share thoughts, dreams, and memories in your private space.": {
        en: "Create a digital notebook together. Share thoughts, dreams, and memories in your private space.",
        es: "Crea un cuaderno digital juntos. Comparte pensamientos, sueños y recuerdos en su espacio privado.",
        de: "Erstellen Sie gemeinsam ein digitales Notizbuch. Teilen Sie Gedanken, Träume und Erinnerungen in Ihrem privaten Bereich."
    },
    "Recipe Discovery": { en: "Recipe Discovery", es: "Descubrimiento de recetas", de: "Rezeptentdeckung" },
    "Find and share recipes to cook together virtually. Make the same meal and enjoy dinner \"together.\"": {
        en: "Find and share recipes to cook together virtually. Make the same meal and enjoy dinner \"together.\"",
        es: "Encuentra y comparte recetas para cocinar juntos virtualmente. Preparen la misma comida y disfruten la cena \"juntos\".",
        de: "Finden und teilen Sie Rezepte, um virtuell gemeinsam zu kochen. Bereiten Sie das gleiche Gericht zu und genießen Sie das Abendessen \"zusammen\"."
    },
    "Movie Matching": { en: "Movie Matching", es: "Coincidencia de películas", de: "Filmauswahl" },
    "Find movies available on both your streaming platforms. Perfect for synchronized movie nights.": {
        en: "Find movies available on both your streaming platforms. Perfect for synchronized movie nights.",
        es: "Encuentra películas disponibles en ambas plataformas de streaming. Perfecto para noches de cine sincronizadas.",
        de: "Finden Sie Filme, die auf beiden Streaming-Plattformen verfügbar sind. Perfekt für synchronisierte Filmabende."
    },
    "Question Games": { en: "Question Games", es: "Juegos de preguntas", de: "Fragespiele" },
    "Discover new things about each other with fun question games designed to deepen your connection.": {
        en: "Discover new things about each other with fun question games designed to deepen your connection.",
        es: "Descubran cosas nuevas el uno del otro con divertidos juegos de preguntas diseñados para profundizar su conexión.",
        de: "Entdecken Sie Neues übereinander mit lustigen Fragespielen, die Ihre Verbindung vertiefen."
    },
    "Your Relationship Dashboard": {
        en: "Your Relationship Dashboard",
        es: "Tu panel de relación",
        de: "Ihr Beziehungs-Dashboard"
    },
    "See everything at a glance - your shared todos, upcoming visits, and relationship milestones. Track your journey together with beautiful timeline features.": {
        en: "See everything at a glance - your shared todos, upcoming visits, and relationship milestones. Track your journey together with beautiful timeline features.",
        es: "Ve todo de un vistazo: tus tareas compartidas, próximas visitas y hitos de la relación. Sigue tu viaje juntos con hermosas funciones de línea de tiempo.",
        de: "Behalten Sie alles im Blick – gemeinsame Aufgaben, bevorstehende Besuche und Meilensteine Ihrer Beziehung. Verfolgen Sie Ihre gemeinsame Reise mit schönen Zeitachsen-Funktionen."
    },
    "Track days together": { en: "Track days together", es: "Sigan los días juntos", de: "Gemeinsame Tage zählen" },
    "Milestone celebrations": { en: "Milestone celebrations", es: "Celebraciones de hitos", de: "Meilenstein-Feiern" },
    "Visit countdown": { en: "Visit countdown", es: "Cuenta regresiva para visitas", de: "Besuchs-Countdown" },
    "Frazza Dashboard": { en: "Frazza Dashboard", es: "Panel de Frazza", de: "Frazza-Dashboard" },
    "See everything at a glance - your shared todos, upcoming visits, and relationship milestones.": {
        en: "See everything at a glance - your shared todos, upcoming visits, and relationship milestones.",
        es: "Ve todo de un vistazo: tus tareas compartidas, próximas visitas y hitos de la relación.",
        de: "Behalten Sie alles im Blick – gemeinsame Aufgaben, bevorstehende Besuche und Meilensteine Ihrer Beziehung."
    },
    "Frazzinema: Your Movie Night Companion": {
        en: "Frazzinema: Your Movie Night Companion",
        es: "Frazzinema: Tu compañero de noches de cine",
        de: "Frazzinema: Ihr Begleiter für Filmabende"
    },
    "Never struggle to find a movie you both can watch again. Our smart platform finds content available on both your streaming services, making movie nights effortless.": {
        en: "Never struggle to find a movie you both can watch again. Our smart platform finds content available on both your streaming services, making movie nights effortless.",
        es: "Nunca más te costará encontrar una película que ambos puedan ver. Nuestra plataforma inteligente encuentra contenido disponible en ambos servicios de streaming, haciendo que las noches de cine sean fáciles.",
        de: "Nie wieder Schwierigkeiten, einen Film zu finden, den Sie beide sehen können. Unsere smarte Plattform findet Inhalte, die auf beiden Streaming-Diensten verfügbar sind, und macht Filmabende mühelos."
    },
    "Shared Calendar: Plan Together, Stay Connected": {
        en: "Shared Calendar: Plan Together, Stay Connected",
        es: "Calendario compartido: Planifiquen juntos, manténganse conectados",
        de: "Gemeinsamer Kalender: Gemeinsam planen, verbunden bleiben"
    },
    "Organize your relationship with a shared calendar. Add events, schedule visits, and see your todos all in one place so you never miss a moment together.": {
        en: "Organize your relationship with a shared calendar. Add events, schedule visits, and see your todos all in one place—so you never miss a moment together.",
        es: "Organiza tu relación con un calendario compartido. Agrega eventos, programa visitas y ve tus tareas en un solo lugar, para que nunca se pierdan un momento juntos.",
        de: "Organisieren Sie Ihre Beziehung mit einem gemeinsamen Kalender. Fügen Sie Ereignisse hinzu, planen Sie Besuche und sehen Sie alle Aufgaben an einem Ort – so verpassen Sie keinen Moment zusammen."
    },
    "Add events together": {
        en: "Add events together",
        es: "Agreguen eventos juntos",
        de: "Fügen Sie gemeinsam Ereignisse hinzu"
    },
    "Create and track visits": {
        en: "Create and track visits",
        es: "Crea y haz seguimiento de visitas",
        de: "Besuche erstellen und verfolgen"
    },
    "Display shared todos": {
        en: "Display shared todos",
        es: "Muestra tareas compartidas",
        de: "Gemeinsame Aufgaben anzeigen"
    },
    "Cross-platform search": { en: "Cross-platform search", es: "Búsqueda multiplataforma", de: "Plattformübergreifende Suche" },
    "Shared watchlists": { en: "Shared watchlists", es: "Listas de seguimiento compartidas", de: "Gemeinsame Watchlists" },
    "Personalized recommendations": { en: "Personalized recommendations", es: "Recomendaciones personalizadas", de: "Personalisierte Empfehlungen" },
    "About Us": { en: "About Us", es: "Sobre nosotros", de: "Über uns" },
    "As a long-distance couple ourselves—Micael in Winterthur, Switzerland, and Anthonella in Göttingen, Germany—we created Frazza to bring everything we wished for into one place. More than just an organizational tool, it's a space to share moments, create memories, enjoy entertainment, and make distance feel a little smaller every day.": {
        en: "As a long-distance couple ourselves—Micael in Winterthur, Switzerland, and Anthonella in Göttingen, Germany—we created Frazza to bring everything we wished for into one place. More than just an organizational tool, it's a space to share moments, create memories, enjoy entertainment, and make distance feel a little smaller every day.",
        es: "Como pareja a distancia—Micael en Winterthur, Suiza, y Anthonella en Göttingen, Alemania—creamos Frazza para reunir todo lo que deseábamos en un solo lugar. Más que una herramienta organizativa, es un espacio para compartir momentos, crear recuerdos, disfrutar del entretenimiento y hacer que la distancia se sienta un poco más pequeña cada día.",
        de: "Als Fernbeziehungspaar – Micael in Winterthur, Schweiz, und Anthonella in Göttingen, Deutschland – haben wir Frazza geschaffen, um alles, was wir uns wünschten, an einem Ort zu vereinen. Mehr als nur ein Organisationstool ist es ein Raum, um Momente zu teilen, Erinnerungen zu schaffen, Unterhaltung zu genießen und die Distanz jeden Tag ein wenig kleiner wirken zu lassen."
    },
    "Support Frazza's Development": {
        en: "Support Frazza's Development",
        es: "Apoya el desarrollo de Frazza",
        de: "Unterstütze die Entwicklung von Frazza"
    },
    "Frazza is free to use. If you enjoy it, consider buying us a coffee to help us grow and improve!": {
        en: "Frazza is free to use. If you enjoy it, consider buying us a coffee to help us grow and improve!",
        es: "Frazza es gratis. Si te gusta, ¡considera comprarnos un café para ayudarnos a crecer y mejorar!",
        de: "Frazza ist kostenlos. Wenn es dir gefällt, spendiere uns einen Kaffee, um uns beim Wachsen und Verbessern zu unterstützen!"
    },
    "Basic": { en: "Basic", es: "Básico", de: "Basis" },
    "Perfect for getting started": { en: "Perfect for getting started", es: "Perfecto para comenzar", de: "Perfekt für den Einstieg" },
    "Shared todos and calendar": { en: "Shared todos and calendar", es: "Tareas y calendario compartidos", de: "Gemeinsame Aufgaben und Kalender" },
    "Basic notes": { en: "Basic notes", es: "Notas básicas", de: "Einfache Notizen" },
    "Movie search": { en: "Movie search", es: "Búsqueda de películas", de: "Filmsuche" },
    "Get Started": { en: "Get Started", es: "Comenzar", de: "Loslegen" },
    "Premium": { en: "Premium", es: "Premium", de: "Premium" },
    "Unleash the full power of connection": {
        en: "Unleash the full power of connection",
        es: "Libera todo el poder de la conexión",
        de: "Entfesseln Sie die volle Kraft der Verbindung"
    },
    "Everything in Basic": { en: "Everything in Basic", es: "Todo lo de Básico", de: "Alles aus Basis" },
    "Recipe discovery": { en: "Recipe discovery", es: "Descubrimiento de recetas", de: "Rezeptentdeckung" },
    "Question games": { en: "Question games", es: "Juegos de preguntas", de: "Fragespiele" },
    "Advanced timeline features": { en: "Advanced timeline features", es: "Funciones avanzadas de línea de tiempo", de: "Erweiterte Zeitachsen-Funktionen" },
    "Priority support": { en: "Priority support", es: "Soporte prioritario", de: "Priorisierter Support" },
    "Start Premium": { en: "Start Premium", es: "Comenzar Premium", de: "Premium starten" },
    "Ready to Strengthen Your Connection?": {
        en: "Ready to Strengthen Your Connection?",
        es: "¿Listo para fortalecer tu conexión?",
        de: "Bereit, Ihre Verbindung zu stärken?"
    },
    "Join thousands of couples who are making distance feel smaller with Frazza.": {
        en: "Join thousands of couples who are making distance feel smaller with Frazza.",
        es: "Únete a miles de parejas que hacen que la distancia se sienta más pequeña con Frazza.",
        de: "Schließen Sie sich Tausenden von Paaren an, die mit Frazza die Distanz kleiner werden lassen."
    },
    "Enter your email": { en: "Enter your email", es: "Introduce tu correo electrónico", de: "Geben Sie Ihre E-Mail ein" },
    "Start Free": { en: "Start Free", es: "Comenzar gratis", de: "Kostenlos starten" },
    "No credit card required. Start connecting today.": {
        en: "No credit card required. Start connecting today.",
        es: "No se requiere tarjeta de crédito. Comienza a conectar hoy.",
        de: "Keine Kreditkarte erforderlich. Beginnen Sie noch heute mit der Verbindung."
    },
    "Full Name": { en: "Full Name", es: "Nombre completo", de: "Vollständiger Name" },
    "Terms of Service": { en: "Terms of Service", es: "Términos de servicio", de: "Nutzungsbedingungen" },
    "Privacy": { en: "Privacy", es: "Privacidad", de: "Datenschutz" },
    "Contact Us": { en: "Contact Us", es: "Contáctanos", de: "Kontakt" },
    "Popular": { en: "Popular", es: "Popular", de: "Beliebt" }
};

const LanguageContext = createContext();

// Provider component
export function LanguageProvider({ children }) {
    const [language, setLanguage] = useState("en");
    const t = (key) => translations[key]?.[language] || key;
    return (
        <LanguageContext.Provider value={{ language, setLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export const useLanguage = () => useContext(LanguageContext);